import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Toolbox } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import Workbench from 'Shared/workbench';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

const Icon = styled(Toolbox)`
   cursor: pointer;
   color: ${color.gray[400]};
`;

const mapStateToProps = (state: any) => ({
   userTopics: state.headerState.userTopics,
});

interface WorkbenchDropdownProps {
   userTopics: any;
}

class WorkbenchDropdown extends Component<WorkbenchDropdownProps> {
   render() {
      const onMount = () => {
         trackInMatomoAndGA({
            eventCategory: 'Workbench',
            eventAction: 'Workbench - Click',
         });
      };

      return (
         <Dropdown
            onMount={onMount}
            icon={<Icon id="workbenchDropdownToggle" aria-label="my workbench" focusable="false" />}
         >
            <Workbench topics={this.props.userTopics} />
         </Dropdown>
      );
   }
}

export default connect(mapStateToProps)(WorkbenchDropdown);
